import { render, staticRenderFns } from "./AvatarChristmas.vue?vue&type=template&id=83f6f2f8&scoped=true"
import script from "./AvatarChristmas.vue?vue&type=script&lang=js"
export * from "./AvatarChristmas.vue?vue&type=script&lang=js"
import style0 from "./AvatarChristmas.vue?vue&type=style&index=0&id=83f6f2f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f6f2f8",
  null
  
)

export default component.exports